(()=>{const d=document,de=d.documentElement,$=s=>d.querySelector(s),$$=s=>[...d.querySelectorAll(s)],on=(el,ev,fn,opt)=>el&&el.addEventListener(ev,fn,opt);

    $('#year')&&( $('#year').textContent=new Date().getFullYear() );

    const mobileMenu=$('#mobileMenu');
    on($('#menuBtn'),'click',()=>mobileMenu?.classList.toggle('hidden'));

    const estBtn  = $('#est-menu-btn');
    const estWrap = $('#est-navwrap');

    if (estBtn && estWrap) {
        const mq = window.matchMedia('(min-width: 1024px)'); // lg

        const sync = () => {
            if (mq.matches) {
                estWrap.classList.remove('hidden');
                estBtn.setAttribute('aria-expanded', 'true');
            } else {
                estWrap.classList.add('hidden');
                estBtn.setAttribute('aria-expanded', 'false');
            }
        };

        const toggle = () => {
            const willShow = estWrap.classList.contains('hidden');
            estWrap.classList.toggle('hidden', !willShow);
            estBtn.setAttribute('aria-expanded', String(willShow));
        };

        on(estBtn, 'click', toggle);

        on(document, 'keydown', (e) => {
            if (e.key === 'Escape' && !mq.matches && !estWrap.classList.contains('hidden')) {
                estWrap.classList.add('hidden');
                estBtn.setAttribute('aria-expanded', 'false');
            }
        });

        (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));
        sync();
    }

    const desktopOpenDetails = $$('details[data-desktop-open]');
    if (desktopOpenDetails.length) {
        const mq = window.matchMedia('(min-width: 768px)'); // md
        const syncDetails = () => {
            for (const details of desktopOpenDetails) {
                details.open = mq.matches;
            }
        };

        (mq.addEventListener ? mq.addEventListener('change', syncDetails) : mq.addListener(syncDetails));
        syncDetails();
    }

    const serviceCompass = $('[data-service-compass]');
    if (serviceCompass) {
        const nodes = [...serviceCompass.querySelectorAll('[data-service-key]')];
        const panelKicker = serviceCompass.querySelector('#service-compass-kicker');
        const panelTitle = serviceCompass.querySelector('#service-compass-title');
        const panelCopy = serviceCompass.querySelector('#service-compass-copy');
        const panelPoints = serviceCompass.querySelector('#service-compass-points');
        const panelLink = serviceCompass.querySelector('#service-compass-link');
        const selectCompassContactService = (value) => {
            const select = $('#service');
            if (!select || !value) return;

            const match = [...select.options].find(option => {
                const optionValue = option.value || option.textContent;
                return optionValue.trim() === value.trim();
            });

            if (match) select.value = match.value || match.textContent;
        };

        const activateService = (button, focus = false) => {
            if (!button) return;

            for (const node of nodes) {
                const isActive = node === button;
                node.classList.toggle('is-active', isActive);
                node.setAttribute('aria-pressed', String(isActive));
            }

            if (panelKicker) panelKicker.textContent = button.dataset.kicker || '';
            if (panelTitle) panelTitle.textContent = button.dataset.title || button.textContent.trim();
            if (panelCopy) panelCopy.textContent = button.dataset.copy || '';
            if (panelPoints) {
                const items = (button.dataset.points || '')
                    .split('|')
                    .map(item => item.trim())
                    .filter(Boolean)
                    .map(item => {
                        const li = d.createElement('li');
                        li.textContent = item;
                        return li;
                    });
                panelPoints.replaceChildren(...items);
            }
            if (panelLink) {
                panelLink.href = button.dataset.href || '#leistungen';
                panelLink.textContent = button.dataset.cta || 'Leistung ansehen';
                panelLink.dataset.contactService = button.dataset.contactService || '';
            }

            if (focus) button.focus();
        };

        panelLink?.addEventListener('click', () => {
            selectCompassContactService(panelLink.dataset.contactService || '');
            setTimeout(() => {
                $('#message')?.focus({ preventScroll: true });
            }, 250);
        });

        window.activateServiceCompass = (key) => {
            const button = nodes.find(node => node.dataset.serviceKey === key);
            if (button) activateService(button);
        };

        serviceCompass.addEventListener('click', (event) => {
            const button = event.target.closest('[data-service-key]');
            if (button) activateService(button);
        });

        serviceCompass.addEventListener('focusin', (event) => {
            const button = event.target.closest('[data-service-key]');
            if (button) activateService(button);
        });

        serviceCompass.addEventListener('pointerover', (event) => {
            if (event.pointerType === 'touch') return;
            const button = event.target.closest('[data-service-key]');
            if (button) activateService(button);
        });

        serviceCompass.addEventListener('keydown', (event) => {
            const button = event.target.closest('[data-service-key]');
            if (!button) return;

            const index = nodes.indexOf(button);
            const nextIndex = {
                ArrowRight: (index + 1) % nodes.length,
                ArrowDown: (index + 1) % nodes.length,
                ArrowLeft: (index - 1 + nodes.length) % nodes.length,
                ArrowUp: (index - 1 + nodes.length) % nodes.length,
                Home: 0,
                End: nodes.length - 1
            }[event.key];

            if (nextIndex !== undefined) {
                event.preventDefault();
                activateService(nodes[nextIndex], true);
            }
        });
    }

    const tabs=$$('.tab-btn');
    if(tabs.length){
        const panels={stack:$('#tab-stack'),special:$('#tab-special'),clients:$('#tab-clients'),solutions:$('#tab-solutions')};
        const activate=(name,focus=false)=>{for(const b of tabs){const a=b.dataset.tab===name;b.setAttribute('aria-selected',a);b.dataset.active=a?'true':'false';if(focus&&a)b.focus();}for(const[k,el]of Object.entries(panels)){if(el)el.hidden=k!==name;}};
        d.addEventListener('click',e=>{const btn=e.target.closest('.tab-btn');if(btn)activate(btn.dataset.tab);});
        d.addEventListener('keydown',e=>{const i=tabs.indexOf(e.target);if(i<0)return;const idx={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i-1+tabs.length)%tabs.length,Home:0,End:tabs.length-1}[e.key];if(idx!=null){e.preventDefault();activate(tabs[idx].dataset.tab,true);}});
        if(!matchMedia('(prefers-reduced-motion: reduce)').matches){const order=['stack','special','clients','solutions'];let k=0;const id=setInterval(()=>{k=(k+1)%order.length;activate(order[k]);},6000);$('#tab-stack')?.parentElement?.addEventListener('mouseenter',()=>clearInterval(id),{once:true});}
    }

    const header = $('header');

    const navLinks = [...$$('a.nav-link[href^="#"]')];
    const brandHome = $('a[href="#home"]');
    if (brandHome && !navLinks.includes(brandHome)) navLinks.push(brandHome);

    if (navLinks.length) {
        const map = new Map();
        for (const a of navLinks) {
            const id = a.getAttribute('href');
            if (id && id.length > 1) map.set(id, a);
        }

        const sections = [...new Set([...map.keys()])]
            .map(h => d.querySelector(h))
            .filter(Boolean);

        let topOffset = (header?.offsetHeight || 72) + 8;
        const setOffset = () => {
            topOffset = (header?.offsetHeight || 72) + 8;
            de.style.setProperty('--top-offset', topOffset + 'px');
        };
        setOffset();

        const setActive = (hash) => {
            for (const a of navLinks) {
                const act = !!hash && a.getAttribute('href') === hash;
                a.classList.toggle('is-active', act);
                a.setAttribute('aria-current', act ? 'true' : 'false');
            }
        };

        let io;
        const build = () => {
            io && io.disconnect();
            io = new IntersectionObserver((entries) => {
                let best = null;
                for (const e of entries) {
                    if (!e.isIntersecting) continue;
                    if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
                }
                if (best) {
                    const id = '#' + best.target.id;
                    if (map.has(id)) setActive(id);
                }
            }, {
                rootMargin: `-${topOffset}px 0px -60% 0px`,
                threshold: [0.1, 0.25, 0.5, 0.75, 1]
            });

            for (const s of sections) io.observe(s);
        };
        build();

        const atTop = () => scrollY <= Math.max(16, topOffset / 2);
        const maybeSetHomeAtTop = () => {
            if (atTop()) {
                if (map.has('#home')) setActive('#home');
                else setActive(null);
            }
        };

        d.addEventListener('click', (e) => {
            const a = e.target.closest('a.nav-link[href^="#"]');
            if (a) mobileMenu && mobileMenu.classList.add('hidden');
        });

        let t;
        on(window, 'resize', () => {
            clearTimeout(t);
            t = setTimeout(() => { setOffset(); build(); maybeSetHomeAtTop(); }, 150);
        }, { passive: true });

        on(window, 'scroll', () => { maybeSetHomeAtTop(); }, { passive: true });

        on(window, 'load', () => {
            setOffset();
            build();
            if (!location.hash && sections[0] && atTop()) {
                if (map.has('#home')) setActive('#home');
                else setActive(null);
            }
        });
    }

    $('#source_url')&&($('#source_url').value=location.href);
    $('#submitted_at')&&($('#submitted_at').value=new Date().toISOString());
    const qs=new URLSearchParams(location.search);
    for(const k of ['utm_source','utm_medium','utm_campaign','utm_term','gclid','gbraid','wbraid']){const el=$('#'+k); if(el) el.value=qs.get(k)||'';}

    const serviceParam = qs.get('service');
    const serviceSelect = $('#service');
    if (serviceParam && serviceSelect) {
        const normalized = serviceParam.toLowerCase();
        const option = [...serviceSelect.options].find(opt => {
            const text = opt.textContent.toLowerCase();
            return text.includes(normalized) || normalized.includes(text);
        });
        if (option) serviceSelect.value = option.value || option.textContent;
    }

    if (qs.get('focus') === 'message') {
        const focusTarget = $('#message');
        focusTarget && setTimeout(() => focusTarget.focus(), 250);
    }

    const ta=$('#message'),cnt=$('#charCount');
    if(ta&&cnt){const upd=()=>{cnt.textContent=ta.value.length}; on(ta,'input',upd); upd();}

    const markErr = (id,msg)=>{
        const el = document.getElementById(id);
        const p  = document.getElementById('err-'+id);
        if(!el||!p) return;
        el.classList.add('is-invalid');
        el.setAttribute('aria-invalid','true');
        p.textContent = msg; p.classList.remove('hidden');

        const ev = (el.type === 'checkbox' || el.type === 'radio') ? 'change' : 'input';
        el.addEventListener(ev, ()=>{
            el.classList.remove('is-invalid');
            el.removeAttribute('aria-invalid');
            p.textContent=''; p.classList.add('hidden');
        }, {once:true});
    };

    const validateClient = ()=>{
        let ok = true;
        const name = document.getElementById('name').value.trim();
        const email= document.getElementById('email').value.trim();
        const msg  = document.getElementById('message').value.trim();
        const privacyEl = document.getElementById('privacy');

        if(!name){ markErr('name','Bitte Namen angeben.'); ok=false; }
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ markErr('email','Bitte gültige E-Mail.'); ok=false; }
        if(msg.length < 5){ markErr('message','Bitte eine kurze Nachricht eingeben.'); ok=false; }
        if(!privacyEl.checked){
            markErr('privacy','Bitte der Datenverarbeitung zustimmen.');
            ok = false;
        }

        return ok;
    };

    const form = document.querySelector('#contact-form');
    if (form) {
        const status = document.querySelector('#form-status');
        const btn = document.querySelector('#submitBtn');

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            // Honeypot
            if (document.querySelector('#hp_field')?.value) return;

            if(!validateClient()){
                status.className = 'mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800 ...';
                status.textContent = 'Bitte korrigieren Sie die markierten Felder.';
                const first = form.querySelector('.is-invalid'); if(first){ first.focus(); first.scrollIntoView({block:'center',behavior:'smooth'}); }
                return;
            }

            if (btn) btn.disabled = true;
            if (status) {
                status.className = 'mb-4 rounded-lg border border-slate-200 bg-white p-3 text-sm dark:border-slate-700 dark:bg-slate-900';
                status.textContent = 'Sende…';
            }

            try {
                const res = await fetch(form.action, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: new FormData(form)
                });

                if (!res.ok) {
                    const json = await res.json().catch(() => null);
                    if (json?.fields) {
                        for (const [id, msg] of Object.entries(json.fields)) {
                            const el = document.getElementById(id);
                            if (!el) continue;
                            el.setAttribute('aria-invalid', 'true');
                            el.classList.add('ring-1', 'ring-red-500', 'focus:outline-none', 'focus:ring-2');
                            el.addEventListener('input', () => {
                                el.removeAttribute('aria-invalid');
                                el.classList.remove('ring-1', 'ring-red-500', 'focus:ring-2');
                            }, { once: true });
                        }
                    }
                    const msg = json?.error || 'Senden fehlgeschlagen. Bitte per E-Mail kontaktieren.';
                    throw new Error(msg);
                }

                const json = await res.json().catch(() => null);
                const redirect = json?.redirect || form.dataset.successRedirect || '/danke';
                if (redirect) {
                    window.location.href = redirect;
                    return;
                }

                form.reset();
                if (status) {
                    status.className = 'mb-4 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800 dark:border-emerald-900/40 dark:bg-emerald-900/20';
                    status.textContent = 'Danke! Ihre Anfrage ist eingegangen. Ich melde mich zeitnah.';
                }
            } catch (err) {
                if (status) {
                    status.className = 'mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800 dark:border-red-900/40 dark:bg-red-900/20';
                    status.textContent = err.message || 'Senden fehlgeschlagen.';
                }
            } finally {
                if (btn) btn.disabled = false;
            }
        });
    }

    const search=$('#guideSearch'),cards=$$('.guide-card'),noRes=$('#noResults');
    if(cards.length){
        const apply=(term='')=>{const t=term.trim().toLowerCase();let vis=0;for(const c of cards){const hit=((c.dataset.tags||'')+' '+c.textContent).toLowerCase().includes(t);c.classList.toggle('hidden',!hit);if(hit)vis++;}noRes?.classList.toggle('hidden',vis!==0);};
        on(search,'input',()=>apply(search.value));
        d.addEventListener('click',e=>{const btn=e.target.closest('.tag-btn');if(!btn)return;const tag=btn.dataset.tag||''; if(search)search.value=tag; apply(tag);});
    }
})();

(() => {
    document.querySelectorAll('#faq [data-accordion]').forEach(group => {
        group.addEventListener('toggle', (e) => {
            const t = e.target;
            if (!(t instanceof HTMLDetailsElement) || !t.open) return;
            group.querySelectorAll('details[open]').forEach(d => { if (d !== t) d.open = false; });
        }, true);
    });
})();
